import { WORK_FROM_HOME_UPDATE } from '../actions'

export default (
    state = {
        shouldFetch: true,
        fetchSuccessful: null,
        goToNextQuestion: false,
        goToNextAllowanceQuestion: false,
        isAllowanceUpdate: false,
    },
    action
) => {
    switch (action.type) {
        case WORK_FROM_HOME_UPDATE:
            return { ...state, ...action.payload }

        default:
            return state
    }
}
